import { render, staticRenderFns } from "./App-Settings.vue?vue&type=template&id=4165c4f4&"
import script from "./App-Settings.vue?vue&type=script&lang=js&"
export * from "./App-Settings.vue?vue&type=script&lang=js&"
import style0 from "./App-Settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports